/**
 * WEB-584: empty browser stub for Node builtins that Turbopack still
 * statically resolves from the instrumentation → @loci/config → winston
 * import chain on Edge / client / dev-fallback targets. The real Node
 * server keeps native modules via `serverExternalPackages: ['winston']`.
 */
export {};
